<template>
  <div class="prize-container">
    <div class="activity-title">奖品说明</div>
    <div class="prize-tips">*奖励将于挑战成功半小时内发放</div>
    <div class="prize-list">
      <div class="prize-item">
        <div class="prize-wrapper">
          <div class="prize-step">
            <div class="rotate-step"
              ><span class="step-num">01</span
              ><span class="step-title">经验值奖</span></div
            >
            <img
              class="step-status"
              :src="getPrizeStatusImage(prize1IsSuccess)"
              alt=""
            />
          </div>
          <div class="step-text">活动期间完成彩蛋任务，<br />即可获得</div>
          <div class="step-text">相应健萌经验值！</div>
        </div>
        <div class="prize-image-list">
          <div class="prize-image-item prize1">
            <img
              class="item-image-prize"
              :class="{ 'item-image-prize-opacity': prize1IsSuccess }"
              src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/dbf86a3a5c711095c04d8970f872e008_wh=231_297.webp"
              alt=""
            />
            <img
              class="item-image-status"
              v-if="prize1IsSuccess"
              src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/680c04ba95f11267644fa5b6a8ee2c80_wh=174_177.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- 二 -->
      <div class="prize-item prize-item-ver">
        <div class="prize-wrapper">
          <div class="prize-step">
            <div class="rotate-step"
              ><span class="step-num">02</span
              ><span class="step-title">目标达成奖</span></div
            >
            <img
              class="step-status"
              :src="getPrizeStatusImage(prize2IsSuccess)"
              alt=""
            />
          </div>
          <div class="step-text">30天内完成挑战目标，即可获得</div>
          <div class="step-tips"
            >挑战达成勋章*1；200元续卡现金券*1
            (现金券所有续卡卡种可用，有效期为获得日起<span class="pink"
              >6个月以内</span
            >）</div
          >
        </div>
        <div class="prize-image-list">
          <div class="prize-image-item prize2">
            <div class="item-image-prize-content">
              <img
                class="item-image-prize"
                src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-04/d59b9a4b746043f5ae6f84bca170b9eb_wh=282_282.webp"
                alt=""
              />
              <img
                class="item-image-status"
                v-if="prize2IsSuccess"
                src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/680c04ba95f11267644fa5b6a8ee2c80_wh=174_177.webp"
                alt=""
              />
            </div>
            <div class="item-prize-name">健萌定制惊喜勋章 (主责门店领取)</div>
          </div>
          <div class="prize-image-item prize3">
            <img
              class="item-image-prize"
              :class="{ 'item-image-prize-opacity': prize2IsSuccess }"
              src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/7e20d5a3bb106217fe3b1f9f1358f78b_wh=267_294.webp"
              alt=""
            />
            <img
              class="item-image-status"
              v-if="prize2IsSuccess"
              src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/680c04ba95f11267644fa5b6a8ee2c80_wh=174_177.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- 3 -->
      <div class="prize-item">
        <div class="prize-wrapper">
          <div class="prize-step">
            <div class="rotate-step"
              ><span class="step-num">03</span
              ><span class="step-title">超额达成奖</span></div
            >
            <img
              class="step-status"
              :src="getPrizeStatusImage(prize3IsSuccess)"
              alt=""
            />
          </div>
          <div class="step-text">超额10%完成挑战目标，<br />即可获得</div>
          <div class="step-tips"
            >200元续卡现金券*1<br />(<span class="pink">6个月及以上</span
            >训练周期可用,<br />有效期为获得日起<span class="pink"
              >6个月以内</span
            >）</div
          >
        </div>
        <div class="prize-image-list">
          <div class="prize-image-item prize4">
            <img
              class="item-image-prize"
              :class="{ 'item-image-prize-opacity': prize3IsSuccess }"
              src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/ebf67489fc2804e73a7abce7718cf728_wh=267_294.webp"
              alt=""
            />
            <img
              class="item-image-status"
              v-if="prize3IsSuccess"
              src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/680c04ba95f11267644fa5b6a8ee2c80_wh=174_177.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="prize-tip-text"
        >*以上3项奖励可同时获得，特定卡种可叠加使用以上优惠券</div
      >
      <div
        class="invite-container"
        v-observe-visibility="handleVisibilityChange"
      >
        <img
          class="invite-image"
          src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-04/4079d1a1510ff99700a642f377f1fae6_wh=1029_630.webp"
          alt=""
        />
        <div class="invite-bottom" v-if="[3, 7].includes(info.project_state)">
          <img
            class="invite-btn"
            @click="bindInviteFriend"
            :src="inviteBtnImage"
            alt=""
          />
          <div class="invite-timeout" v-if="time > 0">
            <van-count-down
              class="my-count-down"
              :time="time"
              format="DD:HH:mm:ss"
              @finish="bindFinish"
            >
              <template #default="timeData">
                <div class="time-container">
                  <div class="time-item">{{ timeData.days | fillZero }}</div>
                  <div class="time-unit">天</div>
                  <div class="time-item">{{ timeData.hours | fillZero }}</div>
                  <div class="time-unit">:</div>
                  <div class="time-item">{{ timeData.minutes | fillZero }}</div>
                  <div class="time-unit">:</div>
                  <div class="time-item">{{ timeData.seconds | fillZero }}</div>
                  <div class="timeout-text">后失效</div>
                </div>
              </template>
            </van-count-down>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      time: 0
    }
  },
  directives: {
    'observe-visibility': {
      bind(el, binding) {
        if (!window.IntersectionObserver) {
          return
        }
        const options = {
          threshold: 0.3
        }
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio >= options.threshold) {
              binding.value(true)
              observer.unobserve(el)
            } else {
              binding.value(false)
            }
          })
        }, options)
        observer.observe(el)
        el.__observer__ = observer
      },
      unbind(el) {
        if (el.__observer__) {
          el.__observer__.disconnect()
          delete el.__observer__
        }
      }
    }
  },
  computed: {
    /* 奖励一是否完成 */
    prize1IsSuccess() {
      return (
        this.info.is_app_article &&
        this.info.is_app_class &&
        this.info.share_url
      )
    },
    prize2IsSuccess() {
      return [3, 7].includes(this.info.project_state)
    },
    prize3IsSuccess() {
      return this.info.project_state == 7
    },
    inviteBtnImage() {
      return this.time > 0
        ? 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/ce9594a67239bbde2124d87602b90423_wh=933_120.png'
        : 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-04/6fbb46dece88d1d19b4ccc539b4be8d4_wh=933_120.webp'
    }
  },
  filters: {
    fillZero(num) {
      return num < 10 ? '0' + num : num
    }
  },
  created() {
    this.time = this.getTime()
  },
  methods: {
    handleVisibilityChange(isVisible) {
      if (isVisible) {
        this.$http.get('member/index?a=shareLogPush', {
          from: `project活动-转介-奖励列表邀请好友按钮曝光-${
            this.$route.query.tfrom || ''
          }`,
          from_id: 250422
        })
      }
    },
    getTime() {
      if ([3, 7].includes(this.info.project_state)) {
        let now = new Date(this.info.server_time.replace(/-/g, '/'))
        let endTime = new Date('2025/05/11 00:00:00')
        let res = endTime.getTime() - now.getTime()
        return res
      } else {
        return 0
      }
    },
    bindFinish() {
      this.time = 0
    },
    //根据任务状态返回奖品状态图标
    getPrizeStatusImage(success) {
      return success
        ? 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/0000689916343cb9b290cd8d26b52341_wh=219_72.webp'
        : 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/960200ee4b46a8ba2167d05523d5e216_wh=171_69.webp'
    },
    //根据任务状态拿是否已获得的图标
    getIconImage(success) {
      return success
        ? 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/0000689916343cb9b290cd8d26b52341_wh=219_72.webp'
        : 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/960200ee4b46a8ba2167d05523d5e216_wh=171_69.webp'
    },
    bindInviteFriend() {
      if (this.time <= 0) {
        return
      }
      this.$emit('jump')
      this.$http.get('member/index?a=shareLogPush', {
        from: `project活动-转介-奖励列表邀请好友按钮点击-${
          this.$route.query.tfrom || ''
        }`,
        from_id: 250422
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.prize-container {
  .activity-title {
    text-align: center;
    font-family: MiSans, MiSans;
    font-weight: bold;
    font-size: 24px;
    color: #ffffff;
    line-height: 23px;
    margin-bottom: 4px;
  }

  .prize-tips {
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    font-size: 13px;
    color: #ffffff;
    line-height: 23px;
    margin-bottom: 12px;
  }

  .prize-list {
    .prize-item {
      background: #ffffff;
      border-radius: 10px;
      padding: 16px 15px 17px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 10px;

      .prize-wrapper {
        .prize-step {
          display: flex;
          align-items: center;
          margin-bottom: 7px;

          .rotate-step {
            font-family: MiSans, MiSans;
            font-weight: bold;
            font-size: 13px;
            color: #ffffff;
            height: 24px;
            margin-right: 6px;
            display: flex;
            align-items: center;
            transform: rotate(-3deg);
            transform-origin: 100% 0%;

            .step-num {
              width: 24px;
              height: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: linear-gradient(to right, #0eb95c 0%, #11cc66 100%);
            }

            .step-title {
              height: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0px 10px;
              background: #11cc66;
            }
          }

          .step-status {
            height: 24px;
            object-fit: contain;
          }
        }

        .step-text {
          font-family: MiSans, MiSans;
          font-weight: bold;
          font-size: 15px;
          color: #000000;
          line-height: 22px;
        }

        .step-tips {
          margin-top: 4px;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.7);
          line-height: 16px;
        }

        .pink {
          color: rgba(234, 57, 129, 1);
        }
      }

      .prize-image-list {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .prize-image-item {
          position: relative;

          .item-image-status {
            position: absolute;
            width: 58px;
            height: 58px;
          }
          .item-image-prize-content {
            margin-left: 28px;
            display: inline-block;
            position: relative;
          }
          .item-image-prize {
            object-fit: contain;
          }

          .item-image-prize-opacity {
            opacity: 0.4;
          }

          .item-prize-name {
            margin-top: 1px;
            text-align: center;
            font-family: MiSans, MiSans;
            font-weight: 400;
            font-size: 11px;
            color: rgba(0, 0, 0, 0.7);
            line-height: 14px;
          }
        }

        .prize1 {
          .item-image-status {
            top: -2px;
            right: -15px;
          }

          .item-image-prize {
            width: 77px;
          }
        }

        .prize2 {
          .item-image-status {
            top: -5px;
            right: -7px;
          }

          .item-image-prize {
            width: 94px;
            height: 94px;
          }
        }

        .prize3 {
          .item-image-status {
            top: -12px;
            right: -13px;
          }

          .item-image-prize {
            width: 89px;
            height: 98px;
          }
        }

        .prize4 {
          .item-image-status {
            top: -12px;
            right: -13px;
          }

          .item-image-prize {
            width: 89px;
            height: 98px;
          }
        }
      }
    }

    .prize-item:last-child {
      margin-bottom: 0;
    }

    .prize-item-ver {
      flex-direction: column;
      align-items: stretch;

      .prize-wrapper {
        margin-bottom: 12px;

        .step-tips {
          margin-top: 0;
        }
      }

      .prize-image-list {
      }
    }

    .prize-tip-text {
      text-align: center;
      font-family: MiSans, MiSans;
      font-weight: bold;
      font-size: 12px;
      color: #ffffff;
      line-height: 16px;
      margin-bottom: 17px;
    }
  }

  .invite-container {
    padding-bottom: 23px;
    background: #ffffff;
    border-radius: 10px;
    margin-bottom: 26px;

    .invite-image {
      width: 100%;
    }

    .invite-bottom {
      padding: 0px 16px;
      margin-top: 19px;

      .invite-btn {
        width: 100%;
        height: 40px;
        object-fit: contain;
      }

      .invite-timeout {
        margin-top: 16px;

        .time-container {
          display: flex;
          align-items: center;
          justify-content: center;

          .time-item {
            width: 18px;
            height: 18px;
            background: #ea3981;
            border-radius: 2px;
            font-weight: bold;
            font-size: 12px;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .time-unit {
            margin: 0px 4px;
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            font-size: 12px;
            color: #ea3981;
            text-align: center;
          }

          .timeout-text {
            margin-left: 9px;
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            font-size: 13px;
            color: #ea3981;
          }
        }
      }
    }
  }
}
</style>
